import React from 'react';

import { useGraphQLQuery } from '@betterment/graphql';
import { Card, H2, Separator } from '@betterment/samba-react';
import { CardLoader } from '@betterment/shared-components';

import { HomeArticlesDocument } from './graphql/query.homeArticles.generated';

import { Article } from '../../Shared/components-v2/article/Article';

const MAX_ARTICLES_TO_DISPLAY = 4;

const ArticlesCard: React.FC = () => {
  const { data } = useGraphQLQuery(HomeArticlesDocument, { throwOnError: true });

  if (!data) return <CardLoader />;

  if (!data.envelopes.length || !data.articles.length) return null;

  const articlesToDisplay = data.articles.slice(0, MAX_ARTICLES_TO_DISPLAY);

  return (
    <Card>
      <Card.Header css={{ padding: 'space.300' }}>
        <H2 variant="title200">Learn</H2>
      </Card.Header>
      <Separator css={{ fullWidthWithInset: 'space.300' }} />
      <Card.Content
        css={{
          padding: 'space.300',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(30rem, 1fr))',
          gap: ['space.200', 'space.300'],
        }}
      >
        {articlesToDisplay.map(article => (
          <Article {...article} key={article.id} />
        ))}
      </Card.Content>
    </Card>
  );
};

export default ArticlesCard;
